import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';

export class StorageRefBuilder {
  static ref(path: string): firebase.storage.Reference {
    return firebase.storage().ref(path);
  }
}
